









































































































































































































































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';

import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import AsociarMensajesFormDetalle from '@/pantallas/CopilotoVirtual/Ruta/AsociarMensajesFormDetalle.vue';
import CabeceraModalCrear from '@/reusable/Modal/CabeceraModalCrear.vue';
import { ServicioProxy } from '@/config/enums';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import CrudStepperHeader from '@/reusable/Mantenedor/CrudStepperHeader.vue';
import CrudStepperItems from '@/reusable/Mantenedor/CrudStepperItems.vue';
import CrudStepperContent from '@/reusable/Mantenedor/CrudStepperContent.vue';
import { AxiosVue } from '@/AxiosVue';
import AsociarFlotaEtiquetaVehiculoIndividual from '@/reusable/AsociarFlotaEtiquetaVehiculoIndividual/AsociarFlotaEtiquetaVehiculoIndividual.vue';
import { fetchReportesSerie } from './fetchReporteSerie';
import moment from 'moment';
import TextField from '@/reusable/Form/TextField.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import config from '@/config/index';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    TextField,
    FormFieldsContainer,
  },
})
export default class VerEditarModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: null }) codigoEquipo: any;

  currentValues: any = {};
  dictionaryFormErrors: any = {};
  optionslist: any = [
    { text: 'Equipo', value: false },
    { text: 'Periferico', value: true },
  ];

  optionslist_2: any = [
    { text: 'ACTIVO', value: false },
    { text: 'INACTIVO', value: true },
  ];
  porductoList: any = [];
  plataformaList: any = [];
  tipoEquipoList: any = [];
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  activaArriendo: boolean = false;
  pasoActivoIndex = 1;
  readonly pasos: PasosCrud = {
    requerimiento: {
      accion: 'Editar Producto',
      visible: true,
      step: 1,
      title: 'Editar Producto',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };

  axios: AxiosVue = new AxiosVue(ServicioProxy.Integracion);
  readonly funcionalidad: Funcionalidades = Funcionalidades.EditarVehiculos;
  id_equipo: any;

  respuesta: any;
  producto: any;
  plataforma: any;
  equipo: any;
  async editar() {
    this.producto = this.formFields.producto.value;
    this.plataforma = this.formFields.plataforma.value;
    this.equipo = this.formFields.tipoequipo.value;
    this.respuesta = await this.$validator.validateAll();
    let self = this;

    if (this.respuesta == false) {
      self.$snotify.error('El formulario presenta errores.', {
        timeout: 3000,
      });
      return;
    }
    this.loadingService.showLoading();

    const valorInstala: any = this.formFields.tipoprodprecio_instala.value
      ? this.formFields.tipoprodprecio_instala.value
      : '0';
    const valorMonitoreo = this.formFields.tipoprodprecio_monitoreo.value
      ? this.formFields.tipoprodprecio_monitoreo.value
      : '0';
    const valorEquipo = this.formFields.tipoprodprecio_equipo.value
      ? this.formFields.tipoprodprecio_equipo.value
      : '0';
    const valorArriendo = this.formFields.tipoprodprecio_arriendo.value
      ? this.formFields.tipoprodprecio_arriendo.value
      : '0';

    return fetchReportesSerie(
      {
        usuarioid_modifica: JSON.parse(localStorage.getItem('user')).id,
        usuariorut_modifica: JSON.parse(localStorage.getItem('user'))
          .rutClienteDefecto,
        tipoproddesc_corta: this.formFields.descripcionCorta.value,
        tipoproddesc_larga: this.formFields.descripcionLarga.value,
        tipoprodcod_producto: this.formFields.codigoProductoP.value,
        tipoprodcod_inet: this.formFields.codigoInet.value,
        tipoprodcuenta_ingreso: this.formFields.cuentaIngreso.value,
        tipoprodcuenta_costo: this.formFields.cuentaCosto.value,
        tipoprodclase: this.producto.configid_clase,
        tipoprodplataforma: this.plataforma.configid_producto,
        tipoprodbaja: this.formFields.estado.value,
        tipoprodid: this.formFields.codigoProducto.value,
        tipoeqid: this.equipo.tipoeqid,
        tipoprodnombre_crm: this.formFields.nombrecrm.value,
        tipoprodglosa: this.formFields.tipoprodglosa.value,
        tipoprodlink: this.formFields.tipoprodlink.value,
        tipoprodprecio_monitoreo: valorMonitoreo,
        tipoprodprecio_instala: valorInstala,
        tipoprodprecio_equipo: valorEquipo,
        tipoprodprecio_arriendo: valorArriendo,
        current_values: this.currentValues,
        activaArriendo: this.activaArriendo,
        visible_cotizador: this.formFields.visible_cotizador.value
      },
      'conecta_matriz_producto_comercial/editar_producto'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.handleCerrar();
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }

  formFields: FormFieldDefMap = {
    nombrecrm: {
      label: 'Nombre en CRM',
      id: '',
      value: '',
    },
    codigoProducto: {
      label: 'ID de Producto',
      id: '',
      value: '',
    },
    codigoProductoP: {
      label: 'Código de Producto',
      id: '',
      value: '',
    },
    codigoInet: {
      label: 'Código de INET',
      id: '',
      value: '',
    },
    descripcionCorta: {
      label: 'Descripción Corta*',
      id: '',
      value: '',
    },
    descripcionLarga: {
      label: 'Descripción Larga*',
      id: '',
      value: '',
    },
    cuentaIngreso: {
      label: 'Cuenta Ingreso',
      id: '',
      value: '',
    },
    cuentaCosto: {
      label: 'Cuenta Costo',
      id: '',
      value: '',
    },
    producto: {
      label: 'Clase Producto',
      id: '',
      value: '',
    },
    plataforma: {
      label: 'Plataforma',
      id: '',
      value: '',
    },
    tipoequipo: {
      label: 'Tipo Equipo',
      id: '',
      value: '',
    },
    estado: {
      label: 'Estado',
      id: '',
      value: '',
    },
    tipoprodglosa: {
      label: 'Glosa',
      id: '',
      value: '',
    },
    tipoprodlink: {
      label: 'Link',
      id: '',
      value: '',
    },
    tipoprodprecio_instala: {
      label: 'Precio de Instalación en UF',
      id: '',
      value: '',
    },
    tipoprodprecio_monitoreo: {
      label: 'Precio de Monitoreo en UF',
      id: '',
      value: '',
    },
    tipoprodprecio_equipo: {
      label: 'Precio de Equipo en UF',
      id: '',
      value: '',
    },
    tipoprodprecio_arriendo: {
      label: 'Precio de Arriendo en UF',
      id: '',
      value: '',
    },
    visible_cotizador: {
      label: 'Visible Cotizador',
      id: 'true',
      value: 'true',
    }
  };
  ocultar: boolean = false;
  async getEquipos() {
    let self = this;
    this.loadingService.showLoading();
    return fetchReportesSerie(
      { '': '' },
      'conecta_matriz_producto_comercial/get_grilla_filters'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.porductoList = data.data.PRODUCTO;
          self.plataformaList = data.data.PLATAFORMA;
          self.tipoEquipoList = data.data.TIPO_EQUIPO;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      })
      .finally(() => {
        this.loadingService.hideLoading();
        return null;
      });
  }
  mounted() {
    this.getEquipos();
    this.formFields.nombrecrm.value = this.codigoEquipo.tipoprodnombre_crm;
    this.formFields.codigoProducto.value = this.codigoEquipo.tipoprodid;
    this.formFields.codigoProductoP.value = this.codigoEquipo.tipoprodcod_producto;
    this.formFields.codigoInet.value = this.codigoEquipo.tipoprodcod_inet;
    this.formFields.descripcionCorta.value = this.codigoEquipo.tipoproddesc_corta;
    this.formFields.descripcionLarga.value = this.codigoEquipo.tipoproddesc_larga;
    this.formFields.cuentaIngreso.value = this.codigoEquipo.tipoprodcuenta_ingreso;
    this.formFields.cuentaCosto.value = this.codigoEquipo.tipoprodcuenta_costo;
    this.formFields.tipoprodglosa.value = this.codigoEquipo.tipoprodglosa;
    this.formFields.tipoprodlink.value = this.codigoEquipo.tipoprodlink;
    this.formFields.tipoprodprecio_monitoreo.value =
      this.codigoEquipo.tipoprodprecio_monitoreo != '0'
        ? this.codigoEquipo.tipoprodprecio_monitoreo
        : null;
    this.formFields.tipoprodprecio_instala.value =
      this.codigoEquipo.tipoprodprecio_instala != '0'
        ? this.codigoEquipo.tipoprodprecio_instala
        : null;
    this.formFields.tipoprodprecio_equipo.value =
      this.codigoEquipo.tipoprodprecio_equipo != '0'
        ? this.codigoEquipo.tipoprodprecio_equipo
        : null;
    this.formFields.tipoprodprecio_arriendo.value =
      this.codigoEquipo.tipoprodprecio_arriendo != '0'
        ? this.codigoEquipo.tipoprodprecio_arriendo
        : null;
    this.currentValues = JSON.parse(JSON.stringify(this.codigoEquipo));

    this.formFields.plataforma.value = {
      producto: this.codigoEquipo.producto,
      configid_producto: this.codigoEquipo.tipoprodplataforma,
    };
    this.formFields.producto.value = {
      configvalor_clase: this.codigoEquipo.clase,
      configid_clase: this.codigoEquipo.tipoprodclase,
    };
    this.formFields.tipoequipo.value = {
      tipoeqname: this.codigoEquipo.tipoeqname,
      tipoeqid: this.codigoEquipo.tipoeqid,
    };

    this.id_equipo = this.codigoEquipo.tipoeqid;
    this.activaArriendo =
      this.codigoEquipo.tipoprodpermite_arriendo == 'f' ? false : true;

    this.formFields.visible_cotizador.value =
      this.codigoEquipo.visible_cotizador == 'f' ? 'false' : 'true';

    if (this.codigoEquipo.tipoprodestado == 'f') {
      this.formFields.estado.value = {
        text: 'ACTIVO',
        value: false,
      };
    } else {
      (this.ocultar = true),
        (this.formFields.estado.value = {
          text: 'INACTIVO',
          value: true,
        });
    }
    this.getEquipos();
    this.dictionaryFormErrors = {
      custom: {
        rut: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        name: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Nombre solo debe contener letras y/o espacios.',
        },
        ubicacion: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        apellidoPaterno: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Paterno solo debe contener letras y/o espacios.',
        },
        apellidoMaterno: {
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Apellido Materno solo debe contener letras y/o espacios.',
        },
        email: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        contrasena: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
        },
        direccion: {
          max: () => config.errorMensajes.maxLength,
        },
        telefonoFijo: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        celular: {
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        estado: {
          required: () => config.errorMensajes.textoRequerido,
        },
        fechaNacimiento: {
          mayorDeEdad: () => config.errorMensajes.fechaMayoriaEdad,
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  @Watch('ReporteSeleccionado')
  handleRutasSeleccionadas() {
    return;
  }

  handleCerrar() {
    this.$emit('cerrarCrear');
  }
}
